const mixin = {
  breadcrumbsLead: [
    {
      text: 'Главная',
      to: { path: '/' },
    },
  ],
  data() {
    return {
      name: 'Программы',
      link: 'events',
    };
  },
  computed: {
    defaultName() {
      return this.name;
    },
    breadcrumbs() {
      const list = [...this.$options.breadcrumbsLead];
      const crumbsPush = (name, params = {}) => {
        list.push({
          text: name,
          to: { name: this.link, params },
        });
      };

      crumbsPush(this.name);

      if (this.sectionData && this.sectionData.name) {
        crumbsPush(this.sectionData.name, {
          section: this.sectionData.code,
        });
      }

      if (this.subsectionData && this.subsectionData.name) {
        crumbsPush(this.subsectionData.name, {
          section: this.sectionData.code,
          subsection: this.subsectionData.code,
        });
      }

      return list;
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/pages/event/mixin.js